import script from "./OrganizationTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationTable.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationTable.vue?vue&type=style&index=0&id=6ec9dd2a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec9dd2a"]])

export default __exports__